var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisible = function SvgVisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.7774 15.367C23.678 12.773 19.9985 9.818 16 9.818C12.0015 9.818 8.32195 12.773 6.22502 15.367C5.92581 15.7379 5.92581 16.2621 6.22502 16.633C8.32195 19.227 12.0039 22.182 16 22.182C19.996 22.182 23.678 19.227 25.775 16.633C26.0742 16.2621 26.0742 15.7379 25.775 15.367H25.7774ZM16.0025 19.2146C14.227 19.2146 12.7878 17.7755 12.7878 16C12.7878 14.2245 14.227 12.7854 16.0025 12.7854C17.7779 12.7854 19.2171 14.2245 19.2171 16C19.2171 17.7755 17.7779 19.2146 16.0025 19.2146Z"
  })));
};
export default SvgVisible;